import React from "react";
import { Avatar } from "@mui/material/";

const ResponsiveImage = ({ src, alt }) => {
    return (
        <Avatar alt={alt} src={src} variant="square" sx={avatarStyle}>
            {!src && alt[0]}{" "}
        </Avatar>
    );
};

// Styles for the Avatar component
const avatarStyle = {
    width: "125px",
    height: "40px",
    objectFit: "contain",
    fontSize: "20px",
    fontWeight: "bold",
    backgroundColor: "transparent",
    color: "black",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px",
    "& img": {
        objectFit: "contain",
        objectPosition: "left"
    }
};

export default ResponsiveImage;
